export const LOGIN = "/report/user/login";
export const REGION = "/report/get-region";
export const ZONES = "report/get-zones";
export const STATES = "report/get-states";
export const CITY = "/report/get-cities";
export const BRANCHES = "/report/get-branches";
export const SEGEMENT = "/report/get-segments";
export const MEMBERSENROLLEMENT = "report/member-enrollment-report";
export const GET_DOWNLOAD_LINK = "/report/get-download-link"
export const CAMPAIGN_TYPES="/report/get-campaign-types"
export const CAMPAIGNREPORT="/report/get-campaign-report"
export const DOWNLOADCAMPAIGNREPORT="/report/download-campaign-report"
export const DOWNLOADTRANSACTIONREPORT="/report/download-acquisition-report"
export const DOWNLOADMEMBERSHIPREPORT="/report/download-member-enrollment-report"
export const POINT_EXPIRY ="/report/get-point-expiry-report"
// export const DOWNLOAD_POINT_EXPIRY ="/report/get-point-expiry-report"
export const LOYALY_PROGRAM_LIST = '/report/loyalty_programs'
export const GET_LIABILITY_REPORT="/report/point_liability_report"
export const GET_FORFEITURE_REPORT="/report/get-point-forfeiture-report"
export const GET_LOYALTY_PROGRAMS="/loyalty_programs"
export const GET_ALL_REDEEMPTION_REPORT="/report/redemption_report";
export const GET_ALL_TRANSACTION_REPORT="/report/point_acquisition_report";
export const DOWNLOAD_REDEEMPTION_REPORT="/report/download-redemption-report";
export const DOWNLOAD_POINT_EXPIRY_REPORT ="/report/download-points-expiry-report";
export const CALL_CENTER_QUERY ="/report/query_types";
export const CALL_CENTER_STATUS ="/report/query_status";
export const GET_CALL_CENTER_REPORT="/report/call_center_query_status_report"
export const DOWNLOAD_CALL_CENTER_REPORT="/report/download_call_center_query_status_report"
export const GET_OTP_REPORT="/report/member-otp-report"
export const DOWNLOAD_OTP_REPORT="/report/download-member-otp-report"
export const NEWMEMBERSENROLLEMENT = "report/new-member-enrollment-report";
export const DOWNLOADNEWMEMBERSHIPREPORT="/report/download-not-loggedin-enrollment-report"
export const UPLOADNEWMEMBERSNOTLOGGEDIN="/report/upload-bulk-enrollment-resend-email"
export const UPLOADNEWMEMBERSFILE="/report/upload-member-resend-email"
export const NF_UPLOAD = "/report/non-financial-transaction/upload";
export const NF_MY_UPLOADS = "/report/non-financial-transaction/my-uploads";
export const NF_UPLOAD_LOG = "/report/non-financial-transaction/upload";
export const NF_AUDIT = "/report/non-financial-transaction/audit";
export const CHANNEL_STATUS = "/channel_status";
export const POINT_APPROVAL_REQUESTS = "/report/point-approval-requests";
export const EXPIRY_SUMMARY = "report/expiry/summary";
export const EXPIRY_UPCOMING = "report/expiry/upcoming";
export const EXPIRY_UPCOMING_DOWNLOAD = "report/expiry/upcoming/download";
export const EXPIRY_EXPIRED = "report/expiry/expired";
export const EXPIRY_EXPIRED_DOWNLOAD = "report/expiry/expired/download";
export const EXPIRY_OVERDUE = "report/expiry/overdue";
export const EXPIRY_OVERDUE_DOWNLOAD = "report/expiry/overdue/download";